import { httpCompanyDetailQueryGateway } from '../../_shared/infrastructure/company-detail-query.http';
import type { CompanyDetailGateway } from './company-detail.gateway';

/** Admin Company Detail → the shared company-detail endpoints (role-guarded server-side). */
export const httpCompanyDetailGateway: CompanyDetailGateway = httpCompanyDetailQueryGateway;
